import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

function ExternalLink({ href, children, title }) {
  return (
    <a href={href} target='_blank' rel='noopener' title={title}>
      {children}
    </a>
  );
}

ExternalLink.propTypes = {
  href: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.string.isRequired,
};

export function CustomizableLink(props) {
  const sourcing = useSelector((state) => state.sourcing);
  const { subscriberData } = sourcing;

  const customStyles = {
    color: subscriberData?.link_color,
    borderColor: subscriberData?.link_color,
  };

  const { href, title, isExternal, children, ...rest } = props;

  if (isExternal) {
    return (
      <a
        href={href}
        style={customStyles}
        title={title}
        target='_blank'
        rel='noopener'
        {...rest}
      >
        {children}
      </a>
    );
  }

  return (
    <a href={href} style={customStyles} title={title} {...rest}>
      {children}
    </a>
  );
}

CustomizableLink.propTypes = {
  href: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.any,
  isExternal: PropTypes.bool,
};

CustomizableLink.defaultProps = {
  isExternal: true,
};

export default ExternalLink;
